<template>
  <div>
    <div class="yk-wrap-fixed wlx-site-manager-wrapper">
      <header class="u-school-manager-head site-manager-head-con">
        <span class="fl sp-test-detail-title">讲师列表</span>
      </header>
      <div class="wlx-table-content">
        <el-table
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;"
          @selection-change="handleTeaSelectionChange"
        >
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="UserName" show-overflow-tooltip label="账号"></el-table-column>
          <el-table-column prop="TeacherName" show-overflow-tooltip label="姓名"></el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">
              <span v-if="scope.row.Gender==0">男</span>
              <span v-else>女</span>
            </template>
          </el-table-column>
          <el-table-column prop="Mobile" show-overflow-tooltip label="手机号"></el-table-column>
          <el-table-column prop="IDNumber" show-overflow-tooltip label="身份证号"></el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                class="el-icon-delete"
                @click="deleteTea(scope.row.Id)"
                titlt="删除"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="wl-pagination-text"
          @size-change="handleTeaSizeChange"
          @current-change="onPageTeaChangeHandler"
          :current-page="pageTeaIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageTeaSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="teaTotal"
          v-show="teaTotal>0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //讲师列表
      list: [],
      pageTeaIndex: 1,
      pageTeaSize: 10,
      teaTotal: 0,
      teachName: ""
    };
  },
  props: {
    siteId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getSetUpTeacherList();
  },
  methods: {
    //获取讲师列表
    getSetUpTeacherList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/SetUpManager/getSetUpTeacherList", {
          teacherName: this.teachName,
          page: page,
          PageSize: this.pageTeaSize
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.list = rst.list;
            that.teaTotal = rst.pagination.totalCount;
            that.pageTeaSize = rst.pagination.pageSize;
            that.pageTeaIndex = rst.pagination.pageIndex;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    handleTeaSelectionChange(val) {
      this.teaIds = [];
      val.forEach(element => {
        this.teaIds.push(element.Id);
      });
    },
    onPageTeaChangeHandler(page) {
      this.getSetUpTeacherList(page);
    },
    handleTeaSizeChange(val) {
      this.pageSize = val;
      this.getSetUpTeacherList(1);
    }
  }
};
</script>

<style lang="scss">
.yk-wrap-fixed {
  .sp-test-detail-title {
    padding: 0 15px;
    font-size: 16px;
    color: #2d82ff;
    // border-bottom: 2px solid #2d82ff;
    line-height: 59px;
    min-width: 30px;
    text-align: center;
  }
  .wlx-table-content {
    margin-top: 84px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    height: 34px;
  }
  .wl-pagination-text {
    text-align: center;
    margin-top: 30px;
  }
  .site-manager-head-con {
    text-align: right;
  }
  .el-form-item__content {
    .el-button {
      padding: 8px 15px;
    }
  }
  .export-button-a {
    color: #fff;
    background: #409eff;
    padding: 8px 15px;
    border-radius: 4px;
    margin: 0 10px;
  }
}
</style>
